<template>
    <div class="tsoft-header">
        <div class="d-flex align-items-center">
            <div>
                <router-link to="/dashboard">
                    <img :src="'/img/logo-tanasoft.svg'">
                </router-link>
            </div>
        </div>
        <div
            class="d-flex align-items-center ml-4"
        >
            <div class="mr-3">
                <div @click="showSupportModal = true" title="Поддержка">
                    <b-iconstack font-scale="2.5" class="cursor-pointer">
                        <b-icon stacked icon="circle-fill" variant="light-gray"></b-icon>
                        <b-icon
                        stacked
                        icon="headset"
                        variant="brown"
                        scale="0.5"
                        ></b-icon>
                    </b-iconstack>
                </div>
            </div>        
            <div class="mr-3">
                <SidebarNotificationsAgent />
            </div>
            <div class="mr-3 d-none d-md-block">
                Ваш ID: {{ currentUser.id }}
            </div>
            <div>
                <div @click="logout">
                    <b-iconstack
                        font-scale="2.5"
                        class="cursor-pointer"
                    >
                        <b-icon
                            stacked
                            icon="circle-fill"
                            variant="light-gray"
                        />
                        <b-icon
                            stacked
                            icon="door-open"
                            scale="0.5"
                            variant="brown"
                        />
                    </b-iconstack>
                </div>
            </div>
        </div>
        
        <!-- Сайдбар поддержки -->
        <b-sidebar 
            v-model="showSupportModal" 
            title="Служба поддержки" 
            right
            width="30rem"
            backdrop
            class="support-sidebar"
        >
            <div class="support-content">
                <div class="mb-4">
                    <h6 class="text-muted">Выберите нужный канал поддержки</h6>
                </div>
                
                <div class="support-channels">
                    <div class="support-channel">
                        <div class="channel-title">📍 @TANAIS_OPERATION</div>
                        <div class="channel-description">
                            <ul class="mb-0">
                                <li>Операционные вопросы</li>
                                <li>Административные вопросы</li>
                                <li>Логистика, документы, работа с клиентами</li>
                            </ul>
                        </div>
                        <a href="https://t.me/TANAIS_OPERATION" target="_blank" class="btn btn-outline-primary btn-block">
                            Написать в Telegram <b-icon icon="telegram" scale="1.3" class="ml-2"></b-icon>
                        </a>
                    </div>
                    
                    <div class="support-channel">
                        <div class="channel-title">📍 @TANAIS_PLATFORM</div>
                        <div class="channel-description">
                            <ul class="mb-0">
                                <li>Технические вопросы по платформе</li>
                                <li>Регистрация, доступ, интерфейс, баги</li>
                            </ul>
                        </div>
                        <a href="https://t.me/TANAIS_PLATFORM" target="_blank" class="btn btn-outline-primary btn-block">
                            Написать в Telegram <b-icon icon="telegram" scale="1.3" class="ml-2"></b-icon>
                        </a>
                    </div>
                    
                    <div class="support-channel">
                        <div class="channel-title">📍 @TANAIS_CURATOR</div>
                        <div class="channel-description">
                            <ul class="mb-0">
                                <li>Адаптация, обучение, советы по эффективности</li>
                                <li>Помощь новичкам и тем, кто хочет расти в проекте</li>
                            </ul>
                        </div>
                        <a href="https://t.me/TANAIS_CURATOR" target="_blank" class="btn btn-outline-primary btn-block">
                            Написать в Telegram <b-icon icon="telegram" scale="1.3" class="ml-2"></b-icon>
                        </a>
                    </div>
                </div>
            </div>
        </b-sidebar>
    </div>
</template>

<script>
    import { mixinTasks } from '@/mixins';
    import { mapGetters, mapActions } from 'vuex';
    
    import SidebarNotificationsAgent from '../../notifications/SidebarNotificationsAgent.vue';
    
    export default {
        components: {
            SidebarNotificationsAgent,
        },
        mixins: [mixinTasks],
        data() {
            return {
                showSupportModal: false,
            };
        },
    
        computed: {
            ...mapGetters('auth', ['currentUser']),
        },
    
        methods: {
            ...mapActions('auth', ['AUTH_LOGOUT']),
        
            logout() {
                this.AUTH_LOGOUT().then(() => {
                    this.$toast.success('Выход выполнен успешно. Хорошего дня! ☀️', {
                        position: 'top-right',
                        timeout: 3000,
                        closeOnClick: true,
                        pauseOnFocusLoss: false,
                        pauseOnHover: false,
                        draggable: true,
                        draggablePercent: 1,
                        showCloseButtonOnHover: true,
                        hideProgressBar: true,
                        closeButton: 'button',
                        icon: 'fa fa-exclamation-triangle',
                        rtl: false,
                    });
                    
                    this.$router.push('/login');
                });
            },
        },
        mounted() {
        },
    };
</script>

<style scoped>
.support-channels {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
}

.support-channel {
    border: 1px solid #e9ecef;
    border-radius: 8px;
    padding: 1.25rem;
    background: #fff;
    transition: all 0.2s ease;
}

.support-channel:hover {
    border-color: #0D6247;
    box-shadow: 0 2px 8px rgba(0, 123, 255, 0.1);
}

.channel-title {
    font-size: 1rem;
    font-weight: 600;
    color: #495057;
    margin-bottom: 0.75rem;
}

.channel-description {
    margin-bottom: 1rem;
}

.channel-description ul {
    padding-left: 1.2rem;
    margin-bottom: 0;
    list-style: disc;
}

.channel-description li {
    margin-bottom: 0.25rem;
    color: #6c757d;
}

.btn-block {
    max-width: 215px;
    padding: 10px 5px;
    font-weight: 600;
    height: 38px;
    text-transform: none;
    line-height: 16px !important;
}

.support-sidebar .sidebar-body {
    padding: 0;
}
</style>